import React, { useState, useEffect } from 'react';

import {
  getFaqs,
  postFaq,
  editFaq,
  deleteFaq,
} from '../../../api/services/faqsApi';

import ContentChangeButton from '../../../components/admin/buttons/ContentChangeButton/ContentChangeButton';
import AdminFaqCard from '../../../components/admin/cards/AdminFaqCard/AdminFaqCard';
import FaqModal from '../../../components/admin/modals/FaqModal/FaqModal';
import ConfirmDeleteModal from '../../../components/admin/modals/ConfirmDeleteModal/ConfirmDeleteModal';

import './AdminFaqs.css';

const AdminFaqs = ({ currentUser }) => {
  const [faqs, setFaqs] = useState([]);
  const [selectedFaq, setSelectedFaq] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editModalMode, setEditModalMode] = useState('edit');

  //Faq Admin Page
  const getAllFaqs = async () => {
    try {
      const allFaqs = await getFaqs();
      setFaqs(allFaqs);
    } catch (err) {
      console.error('Failed to fetch FAQs:', err);
    }
  };

  useEffect(() => {
    getAllFaqs();
  }, []);

  const onAddClickHandler = () => {
    setSelectedFaq({});
    setEditModalMode('add');
    setIsEditModalOpen(true);

    setIsDeleteModalOpen(false);
  };

  const onEditClickHandler = (faq) => {
    setSelectedFaq(faq);
    setEditModalMode('edit');
    setIsEditModalOpen(true);

    setIsDeleteModalOpen(false);
  };

  const onDeleteClickHandler = (faq) => {
    setSelectedFaq(faq);
    setIsDeleteModalOpen(true);

    setIsEditModalOpen(false);
  };

  const onModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedFaq(null);
  };

  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
    setSelectedFaq(null);
  };

  const handleSubmit = async (formData) => {
    try {
      if (editModalMode === 'edit') {
        await editFaq(selectedFaq._id, formData);
        alert('Success! FAQ updated successfully!');
      } else {
        await postFaq(formData);
        alert('Success! FAQ created successfully!');
      }

      await getAllFaqs();
      onModalClose();
    } catch (error) {
      console.error('Submit failed:', error);
      alert('Something went wrong.');
    }
  };

  const onConfirmDelete = async () => {
    try {
      await deleteFaq(selectedFaq._id);
      await getAllFaqs();
      onDeleteModalClose();

      alert(`Deleted! FAQ deleted successfully!`);
    } catch (error) {
      console.error('Delete failed:', error);
      alert('Failed to delete FAQ.');
    }
  };

  return (
    <div id='admin-faq-frame'>
      <div id='admin-faq-container'>
        <div className='admin-faq-title-add-faq-container'>
          <h1 id='faq-list-title'>FAQs</h1>
          <ContentChangeButton
            iconType='add'
            size='large'
            width='long'
            onClickHandler={onAddClickHandler}
          >
            Add FAQ
          </ContentChangeButton>
        </div>
        <div className='faq__layout'>
          {faqs &&
            faqs.map((f) => (
              <AdminFaqCard
                key={f._id}
                faq={f}
                isButtonsDisabled={!currentUser?.isAdmin}
                onEditClickHandler={onEditClickHandler}
                onDeleteClickHandler={onDeleteClickHandler}
              />
            ))}
        </div>
      </div>

      {isEditModalOpen && (
        <FaqModal
          onClose={onModalClose}
          onSubmit={handleSubmit}
          faq={selectedFaq}
          mode={editModalMode}
        />
      )}

      {isDeleteModalOpen && (
        <ConfirmDeleteModal
          onClose={onDeleteModalClose}
          onConfirm={onConfirmDelete}
          deleteItemTitle='this FAQ'
        />
      )}
    </div>
  );
};

export default AdminFaqs;
